<div class="sidenav-menu">
  <app-logo-box />

  <button class="button-close-fullsidebar" (click)="changeSidebarSize()">
    <i class="ri-close-line align-middle"></i>
  </button>


  <ngx-simplebar data-simplebar>
    <div class="sidenav-user">
      <div class="dropdown-center" ngbDropdown>
        <a ngbDropdownToggle
          class="topbar-link dropdown-toggle text-reset drop-arrow-none px-2 d-flex align-items-center justify-content-center"
          data-bs-toggle="dropdown" data-bs-offset="0,19" type="button" aria-haspopup="false" aria-expanded="false">
          <!-- <img src="assets/images/users/avatar-1.jpg" width="42" class="rounded-circle me-2 d-flex" alt="user-image"> -->
          <span class="d-flex flex-column gap-1 sidebar-user-name">
            <h4 class="my-0 fw-bold fs-15">{{user?.name}}</h4>
            <h6 class="my-0">{{user?.email}}</h6>
          </span>
          <i class="ri-arrow-down-s-line d-block sidebar-user-arrow align-middle ms-2"></i>
        </a>
        <div ngbDropdownMenu class="dropdown-menu-end">
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">{{ user?.email }}</h6>
          </div>

          <div class="dropdown-divider"></div>

          <a (click)="logout()" class="cursor-pointer dropdown-item active fw-semibold text-danger">
            <i class="ri-logout-box-line me-1 fs-16 align-middle"></i>
            <span class="align-middle">Sign Out</span>
          </a>
        </div>
      </div>
    </div>
    <ul class="side-nav">
      @for (item of menuItems; track item.label; let first = $first) {
      @if (item.isTitle) {
      <li class="side-nav-title">{{ item.label }}</li>
      } @else {
      @if (hasSubmenu(item)) {
      <ng-container *ngTemplateOutlet="
                MenuItemWithChildren;
                context: {
                  menu: item,
                  linkClassName: 'side-nav-link nav-link-ref',
                  subMenuClassNames: 'sub-menu',
                  itemClassName: 'side-nav-item',
                }
              ">
      </ng-container>
      } @else {
      <ng-container *ngTemplateOutlet="
                MenuItem;
                context: {
                  menu: item,
                  linkClassName: 'side-nav-link nav-link-ref',
                  itemClassName: 'side-nav-item',
                }
              ">
      </ng-container>
      }
      }
      }
    </ul>

    <div class="clearfix"></div>
  </ngx-simplebar>
</div>

<ng-template #MenuItemWithChildren let-menu="menu" let-itemClassName="itemClassName" let-linkClassName="linkClassName"
  let-subMenuClassNames="subMenuClassNames">
  <li [class]="itemClassName" [ngClass]="{ active: activeMenuItems.includes(menu.key) }">
    <a [class]="linkClassName" (click)="toggleMenuItem(menu, collapse)" role="button"
      [attr.aria-expanded]="!menu.collapsed" aria-controls="sidebarDashboards" [attr.aria-controls]="menu.key">
      @if (menu.icon) {
      <span class="menu-icon">
        <i class="{{ menu.icon }}"></i>
      </span>
      }
      <span class="menu-text"> {{ menu.label }} </span>
      <span class="menu-arrow"></span>
    </a>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="menu.collapsed" class="collapse" id="sidebarDashboards">
      <ul [class]="subMenuClassNames">
        @for (child of menu.children; track child.label) {
        @if (hasSubmenu(child)) {
        <ng-container *ngTemplateOutlet="
                MenuItemWithChildren;
                context: {
                  menu: child,
                  linkClassName: 'side-nav-link nav-link-ref',
                  itemClassName: 'side-nav-item',
                  subMenuClassNames: 'sub-menu',
                }
              ">
        </ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="
                MenuItem;
                context: {
                  menu: child,
                  linkClassName: 'side-nav-link nav-link-ref',
                  itemClassName: 'side-nav-item',
                }
              ">
        </ng-container>
        }
        }
      </ul>
    </div>
  </li>
</ng-template>

<ng-template #MenuItem let-menu="menu" let-linkClassName="linkClassName" let-itemClassName="itemClassName">
  <li [class]="itemClassName" [ngClass]="{ active: activeMenuItems.includes(menu.key) }">
    <ng-container *ngTemplateOutlet="
        MenuItemLink;
        context: { menu: menu, className: linkClassName }
      ">
    </ng-container>
  </li>
</ng-template>

<ng-template #MenuItemLink let-menu="menu" let-className="className">
  <a [routerLink]="menu.url" [class]="className" [ngClass]="{
      active: activeMenuItems.includes(menu.key),
      disabled: menu.isDisabled,
    }" [attr.aria-controls]="menu.key">
    @if (menu.icon) {
    <span class="menu-icon">
      <i class="{{ menu.icon }}"></i>
    </span>
    <span class="menu-text">{{ menu.label }}</span>
    } @else {
    {{ menu.label }}
    }
    @if (menu.badge) {
    <span class="badge rounded-pill text-end bg-{{ menu.badge.variant }}">{{
      menu.badge.text
      }}</span>
    }
  </a>
</ng-template>
